import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, InputAdornment, InputLabel, FormControl, Select, MenuItem, FormHelperText } from '@material-ui/core';
import { actionResetFormErrorState, actionSetFormErrorState, actionSetFieldValueState } from 'actions';
import CryptoENC from 'crypto-js/enc-utf8';
import CryptoAES from 'crypto-js/aes'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import theme from '../../theme';
import { CreditCard, VpnKey, DateRange } from '@material-ui/icons';
import { genfunction } from 'helpers';
import { actionPostPaymentTransaction } from 'actions';

const { spreedlyEnvironment, RecaptchaV3Client, StreetAddressTypeID, BillingAddressTypeID, UseStreetAddressForAVS } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    iframebox: {
        marginTop: "-13px",
        height: "31px"
    },
    iconforiframe: {
        marginTop: "18px"
    },
    displaynone: {
        display: "none"
    },
    box100per: {
        width: "100%"
    },
}));

let iframeinputstyle = "font-family: Roboto, Helvetica, Arial, sans-serif; padding: 4px 5px 4px 30px; font-size: 16px;"


const { forwardRef, useRef, useImperativeHandle } = React;

const Spreedly = forwardRef((props, ref) => {

    const customer = useSelector(state => state.reducerCustomer);
    const reducerBooking = useSelector(state => state.reducerBooking);
    let booking = {};

    if (reducerBooking.booking[0] != null) {
        booking = reducerBooking.booking[0];
    }


    useImperativeHandle(ref, () => ({

        TransactionCall(requiredFields) {
            requiredFields["eligible_for_card_updater"] = 'false';
            window.Spreedly.tokenizeCreditCard(requiredFields);
        },
        ZeroDollarTransactionCall(requiredFields) {

            var client = GetClient(requiredFields["first_name"], requiredFields["last_name"],
                requiredFields["email"], UseStreetAddressForAVS ? requiredFields["address1"] : '',
                requiredFields["address2"], requiredFields["city"],
                requiredFields["state"], requiredFields["zip"], requiredFields["country"], requiredFields["phone_number"], requiredFields["shipping_address1"], requiredFields["shipping_address2"],
                requiredFields["shipping_city"], requiredFields["shipping_state"], requiredFields["shipping_zip"], requiredFields["shipping_country"], requiredFields["shipping_phone_number"]);

            if (RecaptchaV3Client && RecaptchaV3Client != '') {
                executeRecaptcha("checkout").then(recaptchaToken => {
                    paymentTokenHandler({ token: null }, client, recaptchaToken);
                }).catch(error => {
                    seterrorMsg("Recaptcha token not fetched")
                })
            }
            else {
                paymentTokenHandler({ token: null }, client, "");
            }
        },
        CardOnFileTransaction() {

            let cardonfileToken = booking.hasOwnProperty('PaymentToken') && booking.PaymentToken.length > 0 ?
                booking.PaymentToken.substring(9, booking.PaymentToken.length) : '';

            if (RecaptchaV3Client && RecaptchaV3Client != '') {
                executeRecaptcha("checkout").then(recaptchaToken => {
                    paymentTokenHandler({ token: cardonfileToken }, customer.customer && customer.customer.length > 0 ? customer.customer : "", recaptchaToken);
                }).catch(error => {
                    seterrorMsg("Recaptcha token not fetched")
                })
            }
            else {
                paymentTokenHandler({ token: cardonfileToken }, customer.customer && customer.customer.length > 0 ? customer.customer : "", "");
            }
        },

        ReloadSpreedly() {
            window.Spreedly.reload();
        },
        PaymentLoaded() {
            return window.Spreedly;
        }

    }));


    //const Spreedly = props => {

    const dispatch = useDispatch();
    const environmentKey = CryptoAES.decrypt(spreedlyEnvironment, '1271').toString(CryptoENC);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const classes = useStyles();

    const errorstate = useSelector(state => state.reducerFormError.errorstate);
    const formfields = useSelector(state => state.reducerFormError.formfields);

    const [errorMsg, seterrorMsg] = useState("");

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://core.spreedly.com/iframe/iframe-v1.min.js";
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => scriptLoaded();
    }, []);

    const GetClient = (firstName, lastName, email, street1, stree2, city, state, postCode, country, mobilePhone, shipping_address1, shipping_address2, shipping_city, shipping_state,
        shipping_zip, shipping_country, shipping_phone_number) => {

        var client = [
            {
                "CustomerType": "Individual",
                "FirstName": firstName,
                "LastName": lastName,
                "CreatedAsGuest": true,
                "GuestEmail": email,
                "DateOfBirth": "",
                "CustomerAddress": [
                    {
                        "IsPrimaryAddress": true,
                        "AddressTypeID": StreetAddressTypeID,
                        "Email": email,
                        "Street1": street1,
                        "Street2": stree2,
                        "CitySuburb": city,
                        "State": state,
                        "Postcode": postCode,
                        "Country": country,
                        "MobilePhone": mobilePhone
                    },
                    {
                        "IsPrimaryAddress": false,
                        "AddressTypeID": BillingAddressTypeID,
                        "Email": email,
                        "Street1": shipping_address1,
                        "Street2": shipping_address2,
                        "CitySuburb": shipping_city,
                        "State": shipping_state,
                        "Postcode": shipping_zip,
                        "Country": shipping_country,
                        "MobilePhone": shipping_phone_number
                    }
                ],
                "LinkedIndividuals": []
            }
        ]

        return client;
    }

    const reseterrorfield = () => {
        window.Spreedly.setStyle("number", iframeinputstyle + "width:100%;border-bottom: 1px solid gray;")
        window.Spreedly.setStyle("cvv", iframeinputstyle + "width:25%;border-bottom: 1px solid gray;")
        actionResetFormErrorState(dispatch);
    }

    const errorfield = (errorfield, errortext, errorstate) => {
        actionSetFormErrorState(dispatch, errorfield, errortext, errorstate)

        if (errorfield === "number")
            window.Spreedly.setStyle("number", iframeinputstyle + "width:100%;border-bottom: 2px solid " + theme.palette.error.main + "; ");
        else if (errorfield === "cvv")
            window.Spreedly.setStyle("cvv", iframeinputstyle + "width:25%;border-bottom: 2px solid " + theme.palette.error.main + "; ");
    }

    const scriptLoaded = () => {

        window.Spreedly.on("ready", () => {
            window.Spreedly.setFieldType("cvv", "text");
            window.Spreedly.setFieldType("number", "text");
            window.Spreedly.setNumberFormat("prettyFormat");
          window.Spreedly.setStyle("number", iframeinputstyle + "width:100%;border-bottom: 1px solid gray;")
            window.Spreedly.setStyle("cvv", iframeinputstyle + "width:25%;border-bottom: 1px solid gray;")
        });

        window.Spreedly.on('errors', (errors) => {
            for (var i = 0; i < errors.length; i++) {
                if (errors[i].key === "errors.blank" || errors[i].key === "errors.invalid" ||
                    errors[i].key === "errors.blank_card_type" || errors[i].key === "errors.expired") {
                    errorfield(errors[i].attribute, errors[i].message, true);
                    window.Spreedly.transferFocus(errors[i].attribute);
                }
                else {
                    window.Spreedly.transferFocus(errors[i].attribute);
                }
            };
        });

        window.Spreedly.on('paymentMethod', (token, pmData) => {

            reseterrorfield();

            var client = GetClient(pmData.first_name, pmData.last_name, pmData.email, UseStreetAddressForAVS ? pmData.address1 : '',
                pmData.address2, pmData.city, pmData.state, pmData.zip, pmData.country, pmData.phone_number, pmData.shipping_address1, pmData.shipping_address2, pmData.shipping_city, pmData.shipping_state,
                pmData.shipping_zip, pmData.shipping_country, pmData.shipping_phone_number);

            if (RecaptchaV3Client && RecaptchaV3Client != '') {
                executeRecaptcha("checkout").then(recaptchaToken => {
                    paymentTokenHandler({ token: token, cardtype: pmData.card_type, cardnumber: pmData.number }, client, recaptchaToken);
                }).catch(error => {
                    seterrorMsg("Recaptcha token not fetched")
                })
            }
            else {
                paymentTokenHandler({ token: token, cardtype: pmData.card_type, cardnumber: pmData.number }, client, "");
            }
        });

        window.Spreedly.init(environmentKey, {
            "numberEl": "spreedly-number",
            "cvvEl": "spreedly-cvv"
        });
    }

    const fieldhandleChange = (event) => {

        if (event.target.name === "MonthSelect" || event.target.name === "YearSelect")
            actionSetFieldValueState(dispatch, event.target.name, event.target.value);
        else
            actionSetFieldValueState(dispatch, event.currentTarget.name, event.target.value);
    };

    const paymentTokenHandler = (token, client, recaptchaToken) => {
        actionPostPaymentTransaction(dispatch, token, client, recaptchaToken);
    }

    return (
        <div>
            {/* className={showFreeTicket || paymenttranstate.loading ? classes.displaynone : classes.visible}  */}

            <Grid container item spacing={2} >
                <Grid item xs={12} sm={6} >
                    <div>
                        <InputLabel error={errorstate.number.errorstate} shrink>
                            Card Number
                        </InputLabel>
                        <InputAdornment className={classes.iconforiframe} position="start">
                            <CreditCard color="primary" />
                        </InputAdornment>
                        <div className={classes.iframebox} id="spreedly-number">

                        </div>
                        <FormHelperText className={errorstate.number.errorstate === false ? classes.diplaynone : ""} error={errorstate.number.errorstate}>{errorstate.number.errortext}</FormHelperText>
                    </div>
                </Grid>


                <Grid item xs={12} sm={6} >
                    <div>
                        <InputLabel error={errorstate.cvv.errorstate} shrink>
                            CVV
                        </InputLabel>
                        <InputAdornment className={classes.iconforiframe} position="start">
                            <VpnKey color="primary" />
                        </InputAdornment>
                        <div className={classes.iframebox} id="spreedly-cvv">

                        </div>
                        <FormHelperText className={errorstate.cvv.errorstate === false ? classes.diplaynone : ""} error={errorstate.cvv.errorstate}>{errorstate.cvv.errortext}</FormHelperText>
                    </div>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <FormControl className={classes.box100per} error={errorstate.month.errorstate}>
                        <InputLabel shrink id="Monthlable">
                            Month
                        </InputLabel>
                        <Select
                            labelId="Monthlable"
                            id="MonthSelect"
                            name="MonthSelect"
                            displayEmpty
                            onChange={fieldhandleChange}
                            value={formfields.MonthSelect.value}
                            IconComponent={() => <DateRange color="primary" />}
                        >
                            {genfunction.GetMonths().map((month, i) => (<MenuItem key={i} value={i + 1}>{month}</MenuItem>))}
                        </Select>
                        <FormHelperText>{errorstate.month.errortext}</FormHelperText>
                    </FormControl>
                </Grid>

                <Grid item xs={6} sm={3}>
                    <FormControl className={classes.box100per} error={errorstate.year.errorstate}>
                        <InputLabel shrink id="Yearlable">
                            Year
                        </InputLabel>
                        <Select
                            labelId="Yearlable"
                            id="YearSelect"
                            name="YearSelect"
                            displayEmpty
                            onChange={fieldhandleChange}
                            value={formfields.YearSelect.value}
                            IconComponent={() => <DateRange color="primary" />}
                        >
                            {genfunction.GetYears(10).map((year, i) => (<MenuItem key={i} value={year}>{year}</MenuItem>))}
                        </Select>
                        <FormHelperText>{errorstate.year.errortext}</FormHelperText>
                    </FormControl>
                </Grid>

            </Grid>

        </div>
    );
});

export default Spreedly;
